import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import { Link } from 'react-router-dom';
import SectionHeader from './partials/SectionHeader';
import Input from '../elements/Input';
import Button from '../elements/Button';
import api from "../../api/http";
import { API_ENDPOINTS } from "../../api/endpoints";
import { ERROR_MESSAGES } from '../../api/errorMsg';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    // ✅ OPTION A: email always empty (no auto-fill)
    this.state = {
      email: '',
      loading: false,
      error: '',
      infoMessage: '',
      submitted: false,
    };

    this.controller = null;
  }

  handleChange = (e) => {
    this.setState({
      email: e.target.value,
      error: '',
      infoMessage: ''
    });
  };

  validateEmail = (email) => {
    return typeof email === 'string' && /\S+@\S+\.\S+/.test(email);
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (!this.validateEmail(email)) {
      this.setState({ error: ERROR_MESSAGES.FORGOT_PASSWORD.INVALID_EMAIL });
      return;
    }

    this.setState({ loading: true, error: '', infoMessage: '' });

    this.controller = new AbortController();
    const signal = this.controller.signal;

    try {
      const res = await api.post(
        API_ENDPOINTS.FORGOT_PASSWORD,
        { email },
        { signal }
      );

      const data = res.data;
      const successMsg =
        data?.message || ERROR_MESSAGES.FORGOT_PASSWORD.OTP_SENT;


      // ✅ still OK: store email for NEXT page (reset-password)
      localStorage.setItem('resetEmail', email);

      this.setState({
        submitted: true,
        infoMessage: successMsg,
        error: ''
      });

      if (this.props.onNext) {
        this.props.onNext(email);
      }

    } catch (err) {
      let msg = ERROR_MESSAGES.FORGOT_PASSWORD.DEFAULT;

      if (err.response) {
        const { status, data } = err.response;
        const backendMsg = data?.message || data?.error;

        if (backendMsg) {
          msg = backendMsg;
        } else if (status === 404) {
          msg = ERROR_MESSAGES.FORGOT_PASSWORD.EMAIL_NOT_FOUND;
        }
      } else if (err.message === 'Network Error') {
        msg = ERROR_MESSAGES.FORGOT_PASSWORD.NETWORK_ERROR;
      }
      this.setState({ error: msg });
    } finally {
      this.setState({ loading: false });
      this.controller = null;
    }
  };

  componentWillUnmount() {
    if (this.controller) this.controller.abort();
  }

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const { email, submitted, loading, error, infoMessage } = this.state;

    const outerClasses = classNames(
      'signin section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'signin-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
      title: 'パスワードをお忘れですか？',
      paragraph: 'メールアドレスを入力してください。再設定コード（OTP）をメールでお送りします。'
    };

    return (
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader tag="h2" data={sectionHeader} className="center-content" />

            <div className="tiles-wrap">
              <div className="tiles-item">
                <div className="tiles-item-inner">
                  {!submitted ? (
                    <form onSubmit={this.handleSubmit}>
                      <fieldset>
                        <div className="mb-12">
                          <Input
                            type="email"
                            name="email"
                            placeholder="メールアドレスを入力してください"
                            value={email}
                            onChange={this.handleChange}
                            labelHidden
                            required
                          />
                        </div>

                        {error && (
                          <div className="text-color-danger mb-12 text-xs">
                            {error}
                          </div>
                        )}
                        {infoMessage && (
                          <div className="text-color-success mb-12 text-xs">
                            {infoMessage}
                          </div>
                        )}

                        <div className="mt-24 mb-32">
                          <Button type="submit" color="primary" wide disabled={loading}>
                            {loading ? '送信中...' : 'OTP を送信'}
                          </Button>
                        </div>

                        <div className="signin-footer mb-32">
                          <Link to="/login/" className="func-link text-xs">
                            サインインに戻る
                          </Link>
                        </div>
                      </fieldset>
                    </form>
                  ) : (
                    <div className="mb-32">
                      <div className="pt-24 pb-24 text-sm center-content text-color-high">
                        <strong>メールを確認してください</strong>
                        <p className="mt-8 text-xs text-color-low">
                          入力された <span className="text-italic">{email}</span> に OTP を送信しました。
                        </p>
                      </div>
                      <div className="pt-16 text-xs center-content">
                        <Link
                          to={{
                            pathname: '/reset-password',
                            state: { email },
                          }}
                          className="func-link"
                        >
                          パスワードを再設定する
                        </Link>
                      </div>
                    </div>
                  )}

                  <div className="signin-bottom has-top-divider">
                    <div className="pt-32 text-xs center-content text-color-low">
                      パスワードを思い出しましたか？{' '}
                      <Link to="/login/" className="func-link">サインイン</Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

ForgotPassword.propTypes = propTypes;
ForgotPassword.defaultProps = defaultProps;

export default ForgotPassword;
